import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { firstName, lastName, phoneNumber } from './common-steps'
import {
  addressLocationLead,
  confirmLead,
  emailAddressLead,
  phoneNumberLead,
  providerAvailability,
  // startLead,
  thanksLead,
} from './lead-steps'

export const leadMobileScenarioA: Scenario = {
  id: 'lead-mobile-a',
  initialStep: Steps.EMAIL_ADDRESS_LEAD,
  type: ScenarioType.LEAD_MOBILE,
  version: '1',
  milestones: [
    // startLead.id,
    emailAddressLead.id,
    addressLocationLead.id,
    providerAvailability.id,
    firstName.id,
    lastName.id,
    phoneNumber.id,
    confirmLead.id,
    thanksLead.id,
  ],
  steps: [
    // startLead,
    emailAddressLead,
    addressLocationLead,
    providerAvailability,
    firstName,
    lastName,
    phoneNumberLead,
    confirmLead,
    thanksLead,
  ],
  weight: 1,
}

export const leadInternetScenarioA: Scenario = {
  id: 'lead-internet-a',
  initialStep: Steps.EMAIL_ADDRESS_LEAD,
  type: ScenarioType.LEAD_INTERNET,
  version: '1',
  milestones: [
    // startLead.id,
    emailAddressLead.id,
    addressLocationLead.id,
    providerAvailability.id,
    firstName.id,
    lastName.id,
    phoneNumber.id,
    confirmLead.id,
    thanksLead.id,
  ],
  steps: [
    // startLead,
    emailAddressLead,
    addressLocationLead,
    providerAvailability,
    firstName,
    lastName,
    phoneNumberLead,
    confirmLead,
    thanksLead,
  ],
  weight: 1,
}
